import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { auth } from '../utils/auth';
import axios from 'axios';
import { Button } from '../components/ui/button';
import { Card } from '../components/ui/card';
import { Scale, Shield, LogOut } from 'lucide-react';
import { toast } from 'sonner';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuditView = () => {
  const navigate = useNavigate();
  const user = auth.getUser();
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAuditLogs();
  }, []);

  const fetchAuditLogs = async () => {
    try {
      const response = await axios.get(`${API}/audit/logs`);
      setLogs(response.data);
    } catch (error) {
      toast.error('Kunne ikke hente revisjonslogger');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-white to-indigo-50">
      <header className="fixed top-0 left-0 right-0 z-50">
        <div className="glass-card mx-6 my-4 px-6 py-4">
          <div className="max-w-7xl mx-auto flex justify-between items-center">
            <div className="flex items-center gap-3">
              <Scale className="w-8 h-8 text-blue-600" />
              <h1 className="text-2xl font-bold text-blue-900">Advokat for alle - Revisjon</h1>
            </div>
            <div className="flex items-center gap-4">
              <span className="text-gray-600">Revisor: {user?.name}</span>
              <Button onClick={auth.logout} variant="outline" data-testid="logout-button">
                <LogOut className="w-4 h-4 mr-2" />
                Logg ut
              </Button>
            </div>
          </div>
        </div>
      </header>

      <main className="pt-32 pb-20 px-6">
        <div className="max-w-6xl mx-auto">
          <div className="flex items-center gap-3 mb-8">
            <Shield className="w-10 h-10 text-blue-600" />
            <div>
              <h2 className="text-3xl font-bold text-blue-900">Revisjonslogg</h2>
              <p className="text-gray-600">Append-only logg over alle privilegerte handlinger</p>
            </div>
          </div>

          {loading ? (
            <div className="text-center py-12">
              <div className="inline-block animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div>
              <p className="mt-4 text-gray-600">Laster logger...</p>
            </div>
          ) : logs.length === 0 ? (
            <Card className="p-12 text-center">
              <p className="text-gray-600">Ingen logger funnet</p>
            </Card>
          ) : (
            <div className="space-y-3" data-testid="audit-logs-list">
              {logs.map((log) => (
                <Card key={log.id} className="p-4 hover:shadow-md transition-shadow">
                  <div className="flex justify-between items-start">
                    <div>
                      <p className="font-semibold text-gray-800">{log.action}</p>
                      <p className="text-sm text-gray-600 mt-1">
                        {log.actor_role} ({log.actor_id}) → {log.object_type} ({log.object_id})
                      </p>
                    </div>
                    <span className="text-sm text-gray-500">
                      {new Date(log.created_at).toLocaleString('no-NO')}
                    </span>
                  </div>
                </Card>
              ))}
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default AuditView;